import NAMES from '~/constants/NAMES';

export const storeToken = (accessToken: string, exp: number): void => {
  sessionStorage.setItem(NAMES.TOKEN, JSON.stringify({ accessToken, exp }));
};

export default storeToken;
